<form [formGroup]="akteFg">
    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="this.optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="akteAanwezig"
                                      id="akteAanwezig"
                                      label="Is er een notariële akte aanwezig?"
    >
    </snelstart-ui-select-form-control>
    <div *ngIf="this.akteFg.getRawValue().akteAanwezig">
        <snelstart-ui-date-form-control (change)="saveForm()"
                                        [required]=true
                                        class="col-auto custom-input-250"
                                        formControlName="datumAkte"
                                        id="datumAkte"
                                        label="Datum akte"
                                        placeholder="dd-mm-jjjj"
        >
        </snelstart-ui-date-form-control>

        <div class="d-flex align-items-center gap-2">
            <snelstart-ui-text-form-control class="custom-input-250"
                                            (change)="saveForm()"
                                            [required]="true"
                                            formControlName="cdrNummer"
                                            id="cdrNummer"
                                            label="CDR nummer">
            </snelstart-ui-text-form-control>
            <span snelstartUiTooltip="Het CDR-nummer bevat altijd 19 nummers; zie toelichtig.">&#x24D8;</span>
        </div>

        <div class="d-flex align-items-center gap-2">
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [required]=true
                                            class="col-auto custom-input-250"
                                            formControlName="notarisProtocolnummer"
                                            id="notarisProtocolnummer"
                                            label="Protocolnummer notaris"
            >
            </snelstart-ui-text-form-control>
            <span snelstartUiTooltip="Het protocolnummer van het notariskantoor bevat altijd 6 nummers; zie toelichtig.">&#x24D8;</span>
        </div>

        <snelstart-ui-text-form-control (change)="saveForm()"
                                        [required]=true
                                        class="col-auto custom-input-250"
                                        formControlName="naamNotariskantoor"
                                        id="naamNotariskantoor"
                                        label="Naam notariskantoor"
        >
        </snelstart-ui-text-form-control>

        <div formGroupName="adresNotariskantoor">

            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [required]=true
                                            class="col-auto custom-input-250"
                                            formControlName="straat"
                                            id="straat"
                                            label="Straat"
            >
            </snelstart-ui-text-form-control>
            <div class="col-auto row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                class="col-auto custom-input-100"
                                                formControlName="postcode"
                                                id="postcode"
                                                label="Postcode"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [showAllDecimals]="false"
                                                  class="col-auto custom-input-100"
                                                  formControlName="huisNummer"
                                                  id="huisNummer"
                                                  label="Nummer"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                class="col-auto custom-input-75"
                                                formControlName="huisNummerToevoeging"
                                                id="huisNummerToevoeging"
                                                label="Toev."
                >
                </snelstart-ui-text-form-control>
            </div>
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            class="col-auto custom-input-250"
                                            formControlName="woonplaats"
                                            id="woonplaats"
                                            label="Plaats"
            >
            </snelstart-ui-text-form-control>

            <snelstart-ui-select-form-control (change)="saveForm()"
                                              [options]="optionsLandcodes"
                                              class="col-auto custom-input-250"
                                              formControlName="landCode"
                                              id="landcode"
                                              label="Land"
            >
            </snelstart-ui-select-form-control>
        </div>
    </div>
</form>
